
import { defineComponent, computed, ref, onMounted } from "vue";
import type { IStudentsModel } from "@/interfaces/modules/aula/IStudentsModel";
import EnrollmentPhysicalFoldersService from "@/api/Configuration/EnrollmentPhysicalFoldersService";
import { IEnrollmentPhysicalFoldersModel } from "@/interfaces/modules";
export default defineComponent({
  name: "TabAcademic",
  props: {
    record: { type: Object as () => IStudentsModel, required: true },
    wasValidated: { type: Boolean, default: false } // NEW: comes from parent
  },
  emits: ["update:record"],
  setup(props, { emit }) {

    const Folders = ref<IEnrollmentPhysicalFoldersModel[]>([]);
    // Two-way proxy for the record prop
    const recordProxy = computed<IStudentsModel>({
      get: () => props.record,
      set: (val) => emit("update:record", val),
    });

    // Immutable field update to ensure the computed setter fires
    const updateField = (key: keyof IStudentsModel, value: any) => {
      recordProxy.value = { ...recordProxy.value, [key]: value };
    };

    const load = async () => {
      Folders.value = await EnrollmentPhysicalFoldersService.GetAll();
    };
    onMounted(load);
    return {
      recordProxy,
      updateField,
      load,
      Folders
    };
  },
});
